import { descriptionRegex } from '@/helpers/products/home';

export default {
  validate: (insuredItemDescription) => {
    return {
      required: true,
      valid: insuredItemDescription && descriptionRegex.test(insuredItemDescription),
    };
  },
  message: (fieldName, { _value_: insuredItemDescription }) => {
    if (!insuredItemDescription) return 'Please enter a short description here.';
    return 'Please enter a valid description without special characters e.g. *,&<>?./~';
  },
  computesRequired: true,
};
